import React, { useEffect, useMemo } from 'react'
import Drawer from '@mui/material/Drawer'
import { makeStyles } from '@mui/styles'
import { useDispatch, useSelector } from 'react-redux'

import Search from '../../../base/components/list/search/search'
import Loader from '../loader/loader'
import Topbar from '../topbar/topbar'
import TaxCategoryItem from './tax-category-item'
import TaxCategorySubItem from './tax-category-sub-item'
import { closeDrawer, getChartsOfAccounts, setSearchTerm } from '../../../../redux/ducks/taxCategories/main'
import lang from '@/lang'

const TaxCategoryDrawer = (props) => {
  const dispatch = useDispatch()
  const { open, isLoading, categories, activeCategory, searchTerm } = useSelector(state => state.taxCategories.main)
  const { onSubmit, accountType } = props
  const classes = useStyles(props)

  useEffect(() => {
    if (!open) {
      dispatch(setSearchTerm(null))
      return
    }

    dispatch(getChartsOfAccounts({ searchTerm, visibility: 'extended', accountType }))
  }, [open, searchTerm, accountType])

  const handleClose = () => {
    dispatch(closeDrawer())
  }

  const handleSearchChange = (searchTerm) => {
    dispatch(setSearchTerm(searchTerm))
  }

  const taxCategories = useMemo(() => {
    return categories.map((category, index) => {
      const { accountCategory } = category
      const active = activeCategory && accountCategory === activeCategory.accountCategory
      return (
        <TaxCategoryItem key={index} category={category} active={active} />
      )
    })
  }, [categories, activeCategory])

  const subCategories = useMemo(() => {
    return activeCategory && activeCategory.accounts.length > 0
      ? activeCategory.accounts.map((account, index) => {
        return (
          <TaxCategorySubItem key={index} account={account} onClick={onSubmit} />
        )
      })
      : (
        <div className={classes.emptyWrapper}>{lang.settings.taxes.noTaxAccountCategoriesFound}</div>
      )
  }, [activeCategory])

  return (
    <Drawer
      open={open}
      anchor="right"
      transitionDuration={400}
      classes={{
        paper: classes.drawer,
      }}
      onClose={handleClose}>
      <div className={classes.wrapper}>
        <Loader visible={isLoading} customClass={classes.loader} />
        <Topbar title='Kategorie wählen' customClass={classes.topbar} dataQsId='taxCategoriesDrawer-topbar'>
          <div>
            <Search placeholder='Stichwort suchen' customClass={classes.search} inputChanged={handleSearchChange} autoFocus />
          </div>
        </Topbar>
        <div className={classes.content}>
          <div className={classes.mainItems}>
            {taxCategories}
          </div>
          <div className={classes.subItems}>
            {subCategories}
          </div>
        </div>
      </div>
    </Drawer>
  )
}

const useStyles = makeStyles(theme => ({
  drawer: {
    width: '60%',
  },
  loader: {
    height: '100%',
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  content: {
    display: 'flex',
    flex: 1,
    minHeight: 0,
  },
  mainItems: {
    flex: '1 0 38%',
    borderRight: `1px solid ${theme.borderColor}`,
    overflow: 'auto',
  },
  subItems: {
    flex: '1 0 62%',
    overflow: 'auto',
  },
  emptyWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 20,
    height: '100%',
  },
  search: {
    width: 230,
    height: 45,
    marginRight: 20,
    marginBottom: 6,
    backgroundColor: theme.white,
    '& input': {
      backgroundColor: theme.white,
    },
    '&>div': {
      border: 0,
      backgroundColor: theme.white,
    },
  },
  topbar: {
    '&>div': {
      paddingRight: '18px',
    },
  },
}))

export default TaxCategoryDrawer
